import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { motion,AnimatePresence } from "framer-motion";
function About() {
 const [index, setIndex] = useState(0);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
   const [formType, setFormType] = useState(""); // stores which button opened the form
 const [showModal, setShowModal] = useState(false);
   const [animate, setAnimate] = useState(false);
   const [loading, setLoading] = useState(false);
 const slides = [
    { text: "End-to-End B2B Demand Generation - Designed for Measurable ROI" },
    { text: "Your Global Partner for Smarter, Scalable Demand Generation" },
    { text: "Driving B2B Success Through Data, Strategy, and Results" },
       { text: "Partnering for Performance. Delivering with Purpose" },
          { text: "Accelerate Your B2B Growth with Precision Marketing" },
  ];
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.5, // delay between each div
    },
  },
};

const handleContactChange = (e) => {
  const { name, value } = e.target;
  setContactForm((prev) => ({ ...prev, [name]: value }));
};
const openModal = () => {
  setShowModal(true);
  setTimeout(() => setAnimate(true), 10); // trigger fade-in animation
};
  // 🔹 Close modal
  const closeModal = () => {
    setAnimate(false);
    setTimeout(() => setShowModal(false), 300);
  };
const [contactForm, setContactForm] = useState({
  fullname: "",
  company: "",
  website: "",
  email: "",
  phone: "",
  message: "",
});
const isBusinessEmail = (email) => {
  const freeDomains = [
    "gmail.com",
    "yahoo.com",
    "hotmail.com",
    "outlook.com",
    "aol.com",
    "icloud.com",
    "mail.com",
    "live.com"
  ];
  const domain = email.split("@")[1]?.toLowerCase();
  if (!domain) return false;
  return !freeDomains.includes(domain);
};

const handleContactSubmit = async (e) => {
  e.preventDefault();
 setLoading(true); // show loading message
  const { fullname, company, website, email, phone, message} = contactForm;
  // Basic validation
  if (!fullname || !email || !message || !company || !phone || !website) {
    alert("Please fill all required fields.");
      setLoading(false); // show loading message

    return;
  }
if (!isBusinessEmail(email)) {
    alert("Please enter a business email, not Gmail/Yahoo/etc.");
      setLoading(false); // show loading message

    return;
  }
 

try {
  // 🔹 Step 1: Validate email existence
  const emailCheckResponse = await fetch(
    `https://pinakinedgemedia.com/api/validateEmail?email=${email}`
  );

  if (!emailCheckResponse.ok) {
    throw new Error("Email validation request failed.");
  }

  const emailCheckData = await emailCheckResponse.json();

  if (!emailCheckData.exists) {
    setLoading(false);
    alert("❌ The entered email does not exist. Please use a valid business email.");
    return;
  }

  // 🔹 Step 2: Send contact mail
  const response = await fetch("https://pinakinedgemedia.com/api/sendContactMail", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      ...contactForm,
      formType,
    }),
  });

  if (response.ok) {
    // ✅ Mail sent successfully
    setShowSuccessModal(true);
    setLoading(false);
    closeModal();

    setContactForm({
      fullname: "",
      company: "",
      website: "",
      email: "",
      phone: "",
      message: "",
    });
  } else {
    // ❌ Backend responded with error
    const errData = await response.json().catch(() => ({}));
    console.error("Mail send failed:", errData);
    alert("❌ Error sending message. Please try again later.");
    setLoading(false);
    closeModal();
  }
} catch (err) {
  // ❌ Any network or unexpected error
  console.error("Unexpected error:", err);
  alert("⚠️ Something went wrong. Please try again later.");
  setLoading(false);
  closeModal();
}

};
// alternate slide: left for odd, right for even
const itemVariants = (direction = "left") => ({
  hidden: { opacity: 0, x: direction === "left" ? -50 : 50 },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 1.8, // slow fade + slide
      ease: "easeInOut",
    },
  },
});
   useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, 4500);
    return () => clearInterval(timer);
  }, [slides.length]);

  const currentSlide = slides[index] ?? { text: "" };

  return (
    
    <div>
      <Header />
       <main>
          
     <AnimatePresence>
          {showSuccessModal && (
            <motion.div
              className="modal-overlay show"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                background: "rgba(0,0,0,0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 9999,
              }}
            >
              <motion.div
                className="modal show"
                initial={{ scale: 0.8, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                exit={{ scale: 0.8, opacity: 0 }}
                transition={{ duration: 0.3 }}
                style={{
                  background: "#fff",
                  padding: "30px",
                  borderRadius: "10px",
                  width: "400px",
                  textAlign: "center",
                  boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
                }}
              >
                <h2 style={{ fontSize: "20px", marginBottom: "10px" }}>
                  Message Sent!
                </h2>
                <p>Thank you for contacting us. We will get back to you shortly.</p>
                <button className="vc rg lk gh ml il hi gi _l"
                  onClick={() => setShowSuccessModal(false)}
                 
                >
                  Close
                </button>
              </motion.div>
            </motion.div>
          )}
        </AnimatePresence>
          {/* 🔹 Modal */}
                {showModal && (
                  <div
                    className={`modal-overlay ${animate ? "show" : ""}`}
                    onClick={(e) => {
                      if (e.target.classList.contains("modal-overlay")) {
                        closeModal();
                      }
                    }}
                    style={{
                      position: "fixed",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      background: "rgba(0, 0, 0, 0.5)",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      zIndex: 1000,
                      opacity: animate ? 1 : 0,
                      transition: "opacity 0.3s ease",
                    }}
                  >
                    <motion.div
                      className="modal-box"
                      initial={{ scale: 0.8, opacity: 0 }}
                      animate={{ scale: 1, opacity: 1 }}
                      exit={{ scale: 0.8, opacity: 0 }}
                      transition={{ duration: 0.3 }}
                      style={{
                        position: "relative",
                        background: "#fff",
                        padding: "30px",
                        borderRadius: "10px",
                        textAlign: "center",
                        boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
                      }}
                    >
                      {/* Close button */}
                      <button
                        onClick={closeModal}
                        style={{
                          position: "absolute",
                          top: "10px",
                          right: "15px",
                          background: "transparent",
                          border: "none",
                          fontSize: "22px",
                          cursor: "pointer",
                          color: "#333",
                        }}
                      >
                        ×
                      </button>
        
                      <h2 className="fk tj kk wm bb">
                       Contact Now
                      </h2>
                   <form onSubmit={(e) => handleContactSubmit(e)}>
  <div className="tc sf yo ap zf xi1">
    <div className="vd to/2">
      <input
        type="text"
        name="fullname"
        id="fullname"
        placeholder="Full name"
        value={contactForm.fullname}
        onChange={handleContactChange}
        className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
      />
    </div>

    <div className="vd to/2">
      <input
        type="text"
        name="company"
        id="company"
         placeholder="Company name"
        value={contactForm.company}
        onChange={handleContactChange}
        className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
      />
    </div>
  </div>

  <div className="tc sf yo ap zf xi1">
    <div className="vd to/2">
      <input
        type="text"
        name="website"
        id="website"
          placeholder="Website"
        value={contactForm.website}
        onChange={handleContactChange}
        className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
      />
    </div>

    <div className="vd to/2">
      <input
        type="email"
        name="email"
         placeholder="Email address"
        id="email"
        value={contactForm.email}
        onChange={handleContactChange}
        className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
      />
    </div>
  </div>

  <div className="tc sf yo ap zf xi1">
    <div className="vd to/2">
     <input
  type="text"
  name="phone"
  id="phone"
    placeholder="Phone number"
  value={contactForm.phone}
  onChange={(e) => {
    // Allow only digits
    const value = e.target.value.replace(/\D/g, "");
    setContactForm((prev) => ({ ...prev, phone: value }));
  }}
  maxLength={10} // optional: limit to 10 digits
  className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
/>

    </div>
  </div>

  <div className="fb">
    <textarea
      placeholder="Message"
      rows="3"
      name="message"
      id="message"
      value={contactForm.message}
      onChange={handleContactChange}
      className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 ci"
    ></textarea>
  </div>

  <div className="tc xf">
      <button
  type="submit"
  className="vc rg lk gh ml il hi gi _l"
  disabled={loading}
>
  {loading ? "Please wait..." : " Send Message"}
</button>

  </div>
</form>
                    </motion.div>
                  </div>
                )}
 <section className="hero-section herovv1">
      <video
        className="hero-video"
        src="/images/aboutmp.mp4"
        autoPlay
        muted
        loop
        loading="lazy"
        playsInline
      />

      <div className="hero-overlay" />

      <div className="hero-content">
        <div className="hero-inner">
          <AnimatePresence mode="wait">
            <motion.h1
              key={index}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -30 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
              className="setslidtext"
            >
              {currentSlide.text}
            </motion.h1>
          </AnimatePresence>
        </div>
      </div>
    </section>
   <section className="i pg qh rm qi relative">
    
 <div className="animate_top bb ze rj ki xn vq">
   <motion.section
     initial={{ opacity: 0, y: 100 }}
     whileInView={{ opacity: 1, y: 0 }}
     viewport={{ once: false, amount: 0.3 }} // 👈 play every time visible
     transition={{
       duration: 1.8,
       ease: "easeOut",
       type: "spring",
       stiffness: 40,
       damping: 20,
     }}
   >
          <h2 className="fk vj pr kk wm on/5 gq/2 bb _b">
         About
          </h2>
          <p className="bb uigy5 jutfy">
                     Pinakinedge Media is a leader in end-to-end global B2B demand generation solutions, and performance marketing services- we’re a trusted growth partner with over 15 years of expertise in the B2B demand generation space. Our mission is simple yet powerful: to empower businesses with high-quality, intent-driven leads and end-to-end marketing solutions that accelerate growth in today’s competitive landscape. Through our operational excellence and proven methodologies, we’ve been delivering top-tier lead generation services that help companies lower cost-per-lead, boost conversions, and strengthen their sales pipeline. We combine data science, creative content, advanced technology, and human expertise with multi-channel strategies to build powerful demand programs designed for precision, scale, and measurable ROI. As a global B2B demand generation and marketing agency, we cover the full funnel - from awareness to conversion.<br/>
                     <br/>   Our comprehensive suite of services includes Sales & Marketing Qualified Leads, Email Marketing, Account-Based Marketing, Content Syndication, Data Intelligence, Data Enrichment, Web Design & Development, Third-Party API Integration, and Social Media Marketing - making us a true one-stop growth partner. What sets us apart is our commitment to being responsive, transparent, and results-driven. We Respond quickly, acknowledge every detail, Meet timelines, and deliver with Transparency - ensuring confidence, control, and customer satisfaction at every step.
                     <br/>   <br/> Trusted by industry leaders worldwide, we leverage behavioral data, actionable intelligence, and decades of B2B experience to create demand, generate revenue, and unlock new opportunities for our clients. With Pinakinedge Media, you don’t just get leads - you get a partner dedicated to helping your business grow smarter, faster, and stronger.

          </p>
          
</motion.section>
        </div>
     </section>
   

     <section>
      
     
      <span className="rc h s r vd fd/5 fh rm"></span>
     
      <div className="bb ze i va ki xn jb jo">
         <motion.section
      variants={containerVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: false, amount: 0.3 }}
    >
        <div className="wc qf pn xo gg">
 
     
           <motion.div variants={itemVariants("left")}  className="animate_top rj divstyabt">
            <div className="c i pg z-1">
              <center>
               <img src="images/vision.png" className="imgsizeicon" alt="Icon" /></center>
            </div>
            <h4 className="ek yj mk2 gb">Vision</h4>
            <p className="hdse">Our vision is to make B2B demand generation smarter, faster, and more effective. Using data, AI, and human expertise, we deliver intent-driven leads and full-funnel strategies that lower costs, shorten sales cycles, and maximize ROI. Through transparency, innovation, and partnership, we build predictable pipelines and help businesses grow with confidence.</p>
         </motion.div>

            <motion.div variants={itemVariants("left")}  className="animate_top rj divstyabt">
            <div className="c i pg z-1">
              <center>
               <img src="images/targeting.png" className="imgsizeicon" alt="Icon" /></center>
            </div>
            <h4 className="ek yj mk2 gb">Mission</h4>
            <p className="hdse">To empower B2B companies with data-driven, AI-enhanced demand generation that converts intent into impact. We blend technology and human insight to create efficient, transparent, and results-focused growth strategies.

</p>
         </motion.div>

           <motion.div variants={itemVariants("left")} className="animate_top rj divstyabt">
            <div className="c i pg z-1">
              <center>
               <img src="images/trophy.png" className="imgsizeicon" alt="Icon" /></center>
            </div>
            <h4 className="ek yj mk2 gb">Goal</h4>
            <p className="hdse">To consistently help B2B clients improve lead quality, reduce acquisition costs, and accelerate sales cycles through innovative, measurable, and partnership-driven demand generation solutions.</p>
          </motion.div>
        
        </div>  
       </motion.section>
      </div>
    </section>
   
       <section className="i ji ii">
       {/* Bg Shapes */}
      <span className="rc h s r vd fd/5 fh rm"></span>
      <img src="/images/shape-08.svg" alt="Shape Bg" className="h q r" />

      {/* Section Title */}
      <div className="animate_top bb ze rj ki xn vq">
      <motion.section
        initial={{ opacity: 0, y: 100 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: false, amount: 0.3 }} // 👈 play every time visible
        transition={{
          duration: 1.8,
          ease: "easeOut",
          type: "spring",
          stiffness: 40,
          damping: 20,
        }}
      ><h2 className="fk vj pr kk wm on/5 gq/2 bb _b">
          Why Choose Us
        </h2></motion.section>
      </div>
      <br/>
      <div className="container">
        <motion.section
         initial={{ opacity: 0, y: 100 }}
         whileInView={{ opacity: 1, y: 0 }}
         viewport={{ once: false, amount: 0.3 }} // 👈 play every time visible
         transition={{
           duration: 1.8,
           ease: "easeOut",
           type: "spring",
           stiffness: 40,
           damping: 20,
         }}
       >
        <div className="left">
          <img src="/images/why2.png" alt="Left Side" />
        </div>
</motion.section>
        {/* Right Side - Content */}
        <div className="right">
            <motion.section
             initial={{ opacity: 0, y: 100 }}
             whileInView={{ opacity: 1, y: 0 }}
             viewport={{ once: false, amount: 0.3 }} // 👈 play every time visible
             transition={{
               duration: 1.8,
               ease: "easeOut",
               type: "spring",
               stiffness: 40,
               damping: 20,
             }}
           >
          <p className="uo">
            At Pinakinedge Media, we go beyond lead generation - we help you create real revenue opportunities. With 15+ years of experience, we focus on delivering high-quality, intent-driven leads that your sales team can actually convert. Our full-funnel strategies blend data intelligence, AI insights, and proven expertise to lower costs, shorten sales cycles, and boost ROI. What makes us different is our simple promise: we work with transparency, speed, and a results-driven mindset - making us a trusted growth partner for B2B companies worldwide.
         </p>
           <div className="tc tf yo zf mb">
          <button
  type="button"
  className="ek jk lk gh gi hi rg ml il vc _d _l"
  onClick={() => {
    setFormType("About Page");
    openModal(true); // or scroll to form if no modal
  }}
>
  Contact Today
</button>
          </div>
         </motion.section>
        </div>
      </div>

    </section>
    </main>
      <Footer />
    </div>
  );
}

export default About;
